import { type SvgIconProps } from '@common/components/svgs/props';

function IconArrowTriangleDown(
  { size = 16, color = 'scheme-feedback-text-color', ...rest }: Readonly<SvgIconProps>,
) {
  return (
    <svg
      {...rest}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="svg-ArrowTriangleDown"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 13.2929L16.2929 9L17.7072 10.4142L13.2728 14.8485C13.2675 14.8539 13.262 14.8594 13.2565 14.8649C13.1723 14.9492 13.0717 15.0498 12.9759 15.1312C12.8648 15.2255 12.6962 15.351 12.4636 15.4266C12.1623 15.5245 11.8378 15.5245 11.5365 15.4266C11.3039 15.351 11.1353 15.2255 11.0242 15.1312C10.9284 15.0498 10.8278 14.9492 10.7436 14.8649C10.7381 14.8594 10.7326 14.8539 10.7273 14.8485L6.29294 10.4142L7.70715 9L12 13.2929Z"
        fill={`var(--${color})`}
      />
    </svg>
  );
}

IconArrowTriangleDown.displayName = 'ArrowTriangleDown';

export default IconArrowTriangleDown;
